module.exports = __webpack_public_path__ + "static/media/kid1.94649855.png";